let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8zZ5r")).then(() => parcelRequire('fOaod'));